import React from 'react'
import { CircleLoader } from 'react-spinners';


export default function LoadingScreen() {
  return (
<>
  <div className='d-flex justify-content-center align-items-center centering'>
    <CircleLoader
      color="#0aad0a"
      size={150}
    />
  </div>
</>
)
}
